import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authReducer, * as fromAuth from 'cm-react/lib/services/auth/reducers';

import userReducer, * as fromUser from '../user/reducers';
import i18n, * as fromI18n from '../i18n/reducer';
import topbar, * as fromTopbar from '../components/TopBar/reducer';

import messengerReducer from '../Messenger/reducers';
import errorReducer from './errorReducer';
import * as commonActions from '../actions';
import rtc from '../RTC/reducers';
import { HELP_MSG_KEY } from '../utils/commons';

const reducers = history =>
  combineReducers({
    i18n: i18n,
    auth: authReducer,
    router: connectRouter(history),
    user: userReducer,
    topbar: topbar,
    messenger: messengerReducer,
    rtc: rtc,
    error: errorReducer
  });

export default history => (state, action) => {
  if (action.type === commonActions.LOGOUT_SUCCESS) {
    // destroy local storage
    const store = require('store');
    store.remove(HELP_MSG_KEY);

    //only keep the app assets
    return reducers(history)(
      {
        i18n: state.i18n,
        importedAuthSDK: state.importedAuthSDK
      },
      action
    );
  }
  return reducers(history)(state, action);
};

export const getAuth = state => state.auth;
export const getMobileNumber = state => fromAuth.getMobileNumber(state.auth);
export const getAccessToken = state => fromAuth.getAccessToken(state.auth);
export const getAuthProvider = state => fromAuth.getAuthProvider(state.auth);
export const getPasswordSaved = state => fromAuth.getPasswordSaved(state.auth);

export const getCurrentLocale = state => fromI18n.getCurrentLocale(state.i18n);
export const getSupportedLocales = state =>
  fromI18n.getSupportedLocales(state.i18n);

export const getUser = state => fromUser.getMe(state.user);

export const showNotificationMenu = state =>
  fromTopbar.showNotificationMenu(state.topbar);
export const showProfileMenu = state =>
  fromTopbar.showProfileMenu(state.topbar);
export const showSideBar = state => fromTopbar.showSideBar(state.topbar);
export const getTopbarMessage = state =>
  fromTopbar.getTopbarMessage(state.topbar);

export const getPathname = state => state.router.location.pathname;
